import React, { useState, useEffect } from 'react';
import { useScrollPosition } from '../../hooks/useScrollPosition';

export const Overlays = () => {
  const scrollY = useScrollPosition();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    setProgress((scrollY / h) * 100);
  }, [scrollY]);

  return (
    <>
      <div className="film-grain" />
      <div className="vignette" />
      <div className="scroll-progress" style={{ width: `${progress}%` }} />
    </>
  );
};